import { BaseContentLayout } from '@components';
import { BORDER_COLORS } from '@constants/colors.ts';
import styled from 'styled-components';

export const ContentLayoutWrapper = styled(BaseContentLayout)`
    padding: 24px;
    margin: 0;
    border-radius: 8px;

    display: flex;
    flex-direction: column;
    overflow-y: auto;
    background: ${BORDER_COLORS.white};
`;
